import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import MotionTrack from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import PaginationStyles from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination.styles';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColour: transparent;
  --fgColour: ${brand.global.black};

  background-color: var(--bgColour);
  color: var(--fgColour);
  overflow: hidden;

  @media ${from(Device.Desktop)} {
    ${SectionWrapperStyles.Inner} {
      display: grid;

      &:has(${PaginationStyles.Container}) {
        grid-template-columns: 1fr min-content;
        column-gap: ${fluid(50, 80)};
      }
    }
  }

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(32, 58)};
  }

  ${PaginationStyles.Container} {
    margin: 32px 0 0;

    @media ${from(Device.Desktop)} {
      margin: 0 0 ${fluid(32, 58)};
      grid-row: 1;
      grid-column: 2 / span 1;
    }
  }
`;
const CarouselWrapper = styled.div `
  --itemPeek: 16px;
  --itemGutter: var(--gutterWidth);
  --visibleItems: 1;

  margin: 0 calc(var(--itemGutter) * -0.5);

  @media ${from(Device.TabletSmall)} {
    --visibleItems: 2;
  }

  @media ${from(Device.TabletLarge)} {
    --visibleItems: 3;
  }

  @media ${from(Device.Desktop)} {
    --itemPeek: 0px;
    --visibleItems: 4;

    grid-row: 2;

    ${Container}:has(${PaginationStyles.Container}) & {
      grid-column: 1 / span 2;
    }
  }
`;
const Track = styled(MotionTrack) ``;
const Item = styled.li `
  display: flex;
  flex: 0 0 calc(100% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
  padding: 0 calc(var(--itemGutter) / 2);

  &[data-is-featured='true'] {
    @media ${from(Device.TabletLarge)} {
      flex: 0 0 calc(200% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
    }
  }
`;
const GenericContentCarouselStyles = {
    CarouselWrapper,
    Container,
    Item,
    Track,
};
export default GenericContentCarouselStyles;
